import { cubeAdminCustomersWithAvailabilityStatus } from "./cubeAdminCustomersWithAvailabilityModel";
import { cubeCustomersViewStatus } from "./cubeCustomersViewModel";

import type { CubeFilter } from "./cubeQueryTypes";

export const crmHomeCustomersViewActiveFilters: CubeFilter[] = [
  { member: cubeCustomersViewStatus, operator: "notEquals", values: ["inactive"] },
];

export const crmHomeAvailabilityViewActiveFilters: CubeFilter[] = [
  { member: cubeAdminCustomersWithAvailabilityStatus, operator: "notEquals", values: ["inactive"] },
];
